import React from 'react'
import "./Footer2.css"
import { FaFacebookSquare, FaLinkedin, FaYoutubeSquare } from "react-icons/fa"
import { NavLink } from 'react-router-dom'

const Footedata = [
    {
        title: "Company",
        list: [
            {
                name: "About us",
                url: "/about"
            },
            {
                name: "Portfolio",
                url: "/portfolio"
            },
            {
                name: "Become a member",
                url: "/career"
            }
        ]
    },
    {
        title: "Pages",
        list: [
            {
                name: "Home",
                url: "/"
            },
            {
                name: "Technical Training",
                url: "/technicalTraining"
            },
            {
                name: "Career",
                url: "/career"
            },
            {
                name: "Contact",
                url: "/contact"
            }
        ]
    },
    {
        title: "Services",
        list: [
            {
                name: "Web Development",
                url: "/webd"
            },
            {
                name: "Mobile App Development",
                url: "/mobiled"
            },
            {
                name: "S/w Dev & OutSourcing",
                url: "/SwDevOutsourcing"
            },
            {
                name: "IT Staffing & Smart Hire",
                url: "/itstaffing"
            },
            {
                name: "Education Support",
                url: "/EducationSupport"
            }
        ]
    },
]
const Footedataicon = [
    {
        title: "Follow us",
        list: [
            {
                icon: <FaFacebookSquare className="facebook" />,
                url: "https://www.facebook.com/icoess?mibextid=LQQJ4d"
            },
            {
                icon: <FaLinkedin className="linkedin" />,
                url: "https://www.linkedin.com/company/icoess/"
            },
            {
                icon: <FaYoutubeSquare className="youtube" />,
                url: "https://www.youtube.com/@icoess?si=TGEg_Ru4cwpHadR7"
            }
        ]
    }
]

const Footer2 = () => {
    return (
        <>
            <footer className='footer'>
                <div className='footer-maindiv'>
                    {Footedata.map((e) => (
                        <div className='footerdata'>
                            <h2>{e.title}</h2>
                            <ul>
                                {e.list.map((data) => (
                                    <NavLink to={data.url}>
                                        <li>{data.name}</li>
                                    </NavLink>
                                ))}
                            </ul>
                        </div>
                    ))}
                    {Footedataicon.map((e) => (
                        <div className='footerdata-icon'>
                            <h2>{e.title}</h2>
                            <ul>
                                {e.list.map((data) => (
                                    <NavLink to={data.url} target='_blank'>
                                        <li>{data.icon}</li>
                                    </NavLink>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
                <div className="footer__rights footer2-copyright-div">
                    <p className="footer__copy">
                        &#169; 2019 - 2025 ICOESS Solutions . All rigths reserved.
                    </p>
                    <div className="footer__terms">
                        <a href="/terms" className="footer__terms-link">
                            Terms & Agreements
                        </a>
                        <a href="/privacyPolicy" className="footer__terms-link">
                            Privacy Policy
                        </a>
                    </div>
                </div>
            </footer>
        </>
    )
}

export default Footer2
